var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectProcessEmissionH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682.667,
    height: 682.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M152.059 10H19.132v51.538h132.927z",
    style: {
      fill: "#6e90ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.059 10H19.132v51.538h132.927z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-132.927l27.255 167.709c9.755-8.209 22.345-13.134 36.077-13.134 14.339 0 27.42 5.373 37.345 14.222z",
    style: {
      fill: "#e2e7ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(152.06 61.536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-31.012-25.14-56.151-56.151-56.151-31.012 0-56.152 25.139-56.152 56.151 0 31.012 25.14 56.152 56.152 56.152C-25.14 56.152 0 31.012 0 0",
    style: {
      fill: "#6e90ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(138.614 272.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-31.012-25.14-56.151-56.151-56.151-31.012 0-56.152 25.139-56.152 56.151 0 31.012 25.14 56.152 56.152 56.152C-25.14 56.152 0 31.012 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(138.614 272.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-134.788-158.647c-2.452 28.763-26.557 51.333-55.949 51.333-.278 0-.555 0-.832-.011L-43.796 39.339a34.101 34.101 0 0 1-.735-7.047c0-18.752 15.213-33.966 33.976-33.966C-6.866-1.674-3.326-1.087 0 0",
    style: {
      fill: "#e2e7ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(273.201 435.729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-132.927l27.255 167.709c9.755-8.209 22.345-13.134 36.077-13.134 14.339 0 27.42 5.373 37.345 14.222z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(152.06 61.536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-134.788-158.647c-2.452 28.763-26.557 51.333-55.949 51.333-.278 0-.555 0-.832-.011L-43.796 39.339a34.101 34.101 0 0 1-.735-7.047c0-18.752 15.213-33.966 33.976-33.966C-6.866-1.674-3.326-1.087 0 0z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(273.201 435.729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-42.548h-148.274a33.733 33.733 0 0 1 4.968 17.686c0 9.819-4.169 18.668-10.832 24.862z",
    style: {
      fill: "#e2e7ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(439.93 492.883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-42.548h-148.274a33.733 33.733 0 0 1 4.968 17.686c0 9.819-4.169 18.668-10.832 24.862z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(439.93 492.883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-162.599l20.137 174.985h122.325z",
    style: {
      fill: "#00ccf2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(470.54 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-162.599l20.137 174.985h122.325z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(470.54 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h207.257",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(285.61 184.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.276 184.985h-66.074v65.651h66.074z",
    style: {
      fill: "#ffce69",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-69.537l20.807-44.145 19.786 44.145V0Z",
    style: {
      fill: "#6e90ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(367.426 450.332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-69.537l20.807-44.145 19.786 44.145V0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(367.426 450.332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-34.648",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(388.232 336.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-18.763-15.21-33.973-33.973-33.973-18.763 0-33.973 15.21-33.973 33.973 0 18.763 15.21 33.973 33.973 33.973C-15.21 33.973 0 18.763 0 0",
    style: {
      fill: "#6e90ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(296.619 468.027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-18.763-15.21-33.973-33.973-33.973-18.763 0-33.973 15.21-33.973 33.973 0 18.763 15.21 33.973 33.973 33.973C-15.21 33.973 0 18.763 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(296.619 468.027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-11.493-9.317-20.811-20.811-20.811-11.493 0-20.81 9.318-20.81 20.811s9.317 20.811 20.81 20.811C-9.317 20.811 0 11.493 0 0",
    style: {
      fill: "#ffce69",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(103.273 272.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-11.493-9.317-20.811-20.811-20.811-11.493 0-20.81 9.318-20.81 20.811s9.317 20.811 20.81 20.811C-9.317 20.811 0 11.493 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(103.273 272.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-58.095",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(83.148 216.111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(83.148 112.991)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectProcessEmissionH);
export default __webpack_public_path__ + "static/media/DirectProcessEmission-h.b62979002b1704ec19a78623152c33be.svg";
export { ForwardRef as ReactComponent };